import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet, API_BASE_URL, logout as apiLogout } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadMe = useCallback(async () => {
        setLoading(true);
        try {
            const d = await apiGet("/me.php");
            setMe(d && d.user ? d.user : null);
        } catch {
            setMe(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadMe();
    }, [loadMe]);

    const login = () => {
        window.location.href = `${API_BASE_URL}/auth_start.php`;
    };

    const logout = async () => {
        try {
            await apiLogout();
        } catch {}
        setMe(null);
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider value={{ me, loading, login, logout, reload: loadMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
